import GenericCloudK8 from './generic-cloud-k8.vue';

export const components = {
  GenericCloudK8
};
